import is from '@sindresorhus/is';
import type { FunctionComponent, PropsWithChildren } from 'react';
import { createContext, useContext, useMemo } from 'react';

import { ApplicationContext } from '~/shared/context/context';

import type { ApplicationFetchers } from './create-application-fetchers';
import { createApplicationFetchers } from './create-application-fetchers';

export const ApplicationFetchersContext = createContext<ApplicationFetchers | null>(null);

type ProviderProps = PropsWithChildren<{
    readonly applicationFetchers?: ApplicationFetchers;
}>;

export const ApplicationFetchersProvider: FunctionComponent<ProviderProps> = ({ applicationFetchers, children }) => {
    const {
        cobrainerApiFetcher,
        realtimeApiFetcher,
        realtimeEventListenerBuilder,
        translate,
        validatingCobrainerApiFetcher,
        validatingRealtimeApiFetcher,
    } = useContext(ApplicationContext);

    const fetchers = useMemo(() => {
        if (is.object(applicationFetchers)) {
            return applicationFetchers;
        }

        return createApplicationFetchers({
            cobrainerApiFetcher,
            realtimeApiFetcher,
            realtimeEventListenerBuilder,
            translate,
            validatingCobrainerApiFetcher,
            validatingRealtimeApiFetcher,
        });
    }, [
        applicationFetchers,
        cobrainerApiFetcher,
        realtimeApiFetcher,
        realtimeEventListenerBuilder,
        translate,
        validatingCobrainerApiFetcher,
        validatingRealtimeApiFetcher,
    ]);

    return <ApplicationFetchersContext.Provider value={fetchers}>{children}</ApplicationFetchersContext.Provider>;
};
